var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendoricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1656 26.6232C24.1656 25.5449 24.4039 24.5249 24.8155 23.5966C23.8256 23.9283 22.7906 24.1233 21.729 24.1233H18.2675C16.5076 24.1233 14.7977 23.6433 13.2994 22.76C11.8011 23.6433 10.0912 24.1233 8.33295 24.1233H6.66636C4.84478 24.1233 3.13986 23.6283 1.66659 22.7783V35.7894C1.66659 38.546 3.90982 40.7892 6.66636 40.7892H19.9991V37.456C19.9991 34.0845 22.014 31.1713 24.9005 29.8614C24.4289 28.8814 24.1656 27.7814 24.1656 26.6232ZM36.03 0.791016H28.332V9.12397H24.9989V0.791016H14.9993V9.12397H11.6661V0.791016H3.96815L0 12.3722V14.1887C0 17.8302 2.98986 20.7901 6.66636 20.7901H8.33295C10.3229 20.7901 12.0894 19.8768 13.3011 18.4669C14.5127 19.8785 16.2776 20.7901 18.2692 20.7901H21.7307C23.7206 20.7901 25.4872 19.8785 26.6988 18.4669C27.1871 19.0352 27.7837 19.4918 28.4287 19.8718C29.4103 19.4002 30.5036 19.1235 31.6669 19.1235C33.1685 19.1235 34.5651 19.5685 35.7384 20.3285C38.2266 19.3702 39.9998 16.9869 39.9998 14.1887V12.3722L36.0317 0.791016L36.03 0.791016Z",
    fill: "#4F4E4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0018 40.7851V37.452C40.0018 34.6954 37.7586 32.4522 35.0021 32.4522H28.3357C25.5792 32.4522 23.3359 34.6954 23.3359 37.452V40.7851H40.0018Z",
    fill: "#AD4EFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6689 30.7856C29.3707 30.7856 27.5024 28.9173 27.5024 26.6191C27.5024 24.3209 29.3707 22.4526 31.6689 22.4526C33.9671 22.4526 35.8354 24.3209 35.8354 26.6191C35.8354 28.9173 33.9671 30.7856 31.6689 30.7856Z",
    fill: "#AD4EFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendoricon);
export default __webpack_public_path__ + "static/media/vendoricon.6c41baa90cafe07affb3a8c8f9cae067.svg";
export { ForwardRef as ReactComponent };